export default __webpack_public_path__ + "static/media/blogn-xs.25f24204.svg";